import { useState, type ReactElement, type ReactNode } from 'react';

import {
    OnboardingContext,
    type AccountForm,
    type CompanyForm,
    type RegistrationChannelForm,
    type ValidationForm,
} from './onboardingContext';
import type { OnboardingProviderSeed } from './onboardingProviderSeed';

const initialCompany: CompanyForm = {
    companyName: '',
    street: '',
    nr: '',
    city: '',
    postcode: '',
    website: '',
    employees: '',
};

const initialAccount: AccountForm = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
};

const initialValidation: ValidationForm = {
    uid: '',
};

export function OnboardingProvider({
    children,
    seed,
}: {
    children: ReactNode;
    seed?: OnboardingProviderSeed;
}): ReactElement {
    const [workCategories, setWorkCategories] = useState<Set<string>>(() => new Set());
    const [regions, setRegions] = useState<Set<string>>(() => new Set());
    const [account, setAccount] = useState<AccountForm>({ ...initialAccount, ...seed?.account });
    const [company, setCompany] = useState<CompanyForm>({ ...initialCompany, ...seed?.company });
    const [validation, setValidation] = useState<ValidationForm>({ ...initialValidation, ...seed?.validation });
    const [registrationChannel, setRegistrationChannel] = useState<RegistrationChannelForm>({
        ...seed?.registrationChannel,
    });

    return (
        <OnboardingContext.Provider
            value={{
                workCategories,
                setWorkCategories,
                regions,
                setRegions,
                account,
                setAccount,
                company,
                setCompany,
                validation,
                setValidation,
                registrationChannel,
                setRegistrationChannel,
            }}>
            {children}
        </OnboardingContext.Provider>
    );
}
